module.exports = __webpack_public_path__ + "img/DE01553.88aceb65.png";